<template>
  <el-dialog
    :title="$t('SeaExport.PreviewOfBookingFileParsing')"
    custom-class="intelligent-booking-result-dialog"
    :visible.sync="innerVisible"
    fullscreen
    :modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
  >
    <cargo-left-right-resize
      style="width:100%;height: 100%;"
      :left-style="{'min-width': '550px',width:'50%'}"
      :right-style="{'min-width': '550px',width:'50%'}"
    >
      <template slot="left">
        <div style="width: 100%;height:100%;overflow: auto;">
          <image-preview v-if="visible" :image-info="resultJson" :cur-focus="curFocus" /></div>
      </template>
      <template slot="right">
        <div style="width: 100%;height:100%;overflow: auto;">
          <result-form v-if="visible" ref="resultForm" :details="details" @fieldFocus="(val)=>curFocus=val" />
        </div>
      </template>
    </cargo-left-right-resize>
    <div v-if="details.status === 3" slot="footer" style="text-align: center">
      <el-button no="1" @click="handleClose">{{ $t('Message.Close') }}</el-button>
    </div>
    <div v-else slot="footer" style="text-align: center">
      <el-button no="2" type="success" @click="handleSave">{{ $t('Payment.save') }}</el-button>
      <el-button no="3" type="primary" @click="handleCreateOrder">{{ $t('SeaExport.GenerateOrder') }}</el-button>
      <el-button no="4" @click="handleClose">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreview from '@/views/cargo/v0/ToolAssistant/ocr/components/ImagePreview'
import ResultForm from '@/views/cargo/v0/ToolAssistant/ocr/components/ResultForm'
import { saveResultJson } from '@/api/seaExport/intelligentBooking'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import DateUtils from '@/utils/dateUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { SALES_CHANNEL_OCR_RECOGNITION } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'IntelligentBookingResult',
  components: { ResultForm, ImagePreview, CargoLeftRightResize },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      curFocus: ''
    }
  },
  computed: {
    resultJson() {
      return this.details.resultJson ? JSON.parse(this.details.resultJson) : null
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    }
  },
  methods: {
    async handleCreateOrder() {
      const resultJson = this.$refs.resultForm.resultJson ? this.$refs.resultForm.resultJson : []
      const oldJob = {}
      this.$logger.log('resultJson=========', resultJson)
      Object.keys(resultJson).forEach(key => {
        const valueKeys = Object.keys(resultJson[key]).filter(itemKey => {
          return itemKey.match('value')
        })
        console.log(key, valueKeys)
        if (valueKeys.length === 0) {
          oldJob[key] = {
            value: resultJson[key]
          }
        }
        if (valueKeys.length === 1) {
          if (resultJson[key].hasOwnProperty('convertValue')) {
            oldJob[key] = {
              value: resultJson[key].value,
              convertValue: resultJson[key].convertValue
            }
          } else if (resultJson[key].hasOwnProperty('codes') && resultJson[key].codes.length > 0) {
            oldJob[key] = {
              value: resultJson[key].value,
              code: resultJson[key].codes[0].code
            }
          } else {
            oldJob[key] = {
              value: resultJson[key].value
            }
          }
        }
        if (valueKeys.length > 1) {
          valueKeys.forEach(valueKey => {
            oldJob[key + 'Line' + valueKey.replace('value', '')] = resultJson[key][valueKey]
          })
        }
      })
      this.$emit('close')
      const job = await this.convertJsonToJob(oldJob)
      this.$logger.log('job=========', job)
      job.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
      if (this.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code) { // 远程订舱-海运
        job.lob = 'SE'
        this.$router.push({
          name: 'RemoteBooking',
          params: {
            view: 'detail',
            action: 'add',
            job,
            source: this.source
          }
        })
        return
      }
      this.$router.push({ name: 'SeaBooking', params: { job }})
    },
    handleSave() {
      const loading = getLoading()
      const params = {
        uuid: this.details.uuid,
        resultJson: this.$refs.resultForm.resultJson
      }
      saveResultJson(params).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('success')
      }).finally(() => {
        loading.close()
      })
    },
    handleClose() {
      console.log('result close')
      this.$emit('close')
    },
    async convertJsonToJob(job) {
      const newJob = {}
      // 发货人
      this.scnChange(job, newJob, 'shipperLine', 'shipperLine')
      // 收货人
      this.scnChange(job, newJob, 'consigneeLine', 'consigneeLine')
      // 通知人
      this.scnChange(job, newJob, 'notifyPartyLine', 'notifyLine')
      // 起运港
      const loadingPortCode = this.changeCodeValue(job, 'portOfLoading', TYPE_NAMES.basic_data_Seaport, 'englishName')
      newJob.loadingPortCode = loadingPortCode === null ? '' : loadingPortCode
      // 卸货港
      const dischargingPortCode = this.changeCodeValue(job, 'portOfDischarge', TYPE_NAMES.basic_data_Seaport, 'englishName')
      newJob.dischargingPortCode = dischargingPortCode === null ? '' : dischargingPortCode
      // 中转港
      const transferPortCode = this.changeCodeValue(job, 'transitPort', TYPE_NAMES.basic_data_Seaport, 'englishName')
      newJob.transferPortCode = transferPortCode === null ? '' : transferPortCode
      // 交货地
      const destinationPortCode = this.changeCodeValue(job, 'placeOfDelivery', TYPE_NAMES.basic_data_Seaport, 'englishName')
      newJob.destinationPortCode = destinationPortCode === null ? '' : destinationPortCode
      if (newJob.destinationPortCode === '' && newJob.dischargingPortCode !== '') {
        newJob.destinationPortCode = newJob.dischargingPortCode
      }
      newJob.etd = this.toDateStr(job.etd.value)
      newJob.sailingDay = DateUtils.getDateWeek(newJob.etd)
      // 船公司
      const carrierId = this.changeCodeValue(job, 'shipName', TYPE_NAMES.basic_data_Company, 'shortName', 'cmpIdx', true)
      newJob.carrierId = carrierId === null ? 0 : carrierId
      // 船名
      newJob.vessel = job.vessel.value
      if (newJob.vessel && newJob.vessel.length > 64) {
        newJob.vessel = newJob.vessel.substr(0, 64)
      }
      await cache.load(cacheName.CONFIG)
      const showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
      let voyageValue = 'V.'
      if (!showJudgmentOfVoyageNo) {
        voyageValue = ''
      }
      newJob.voyageFlight = StrUtils.isEmpty(job.voyageFlight) ? voyageValue + job.voyage.value : job.voyage.value
      if (newJob.voyageFlight && newJob.voyageFlight.length > 255) {
        newJob.voyageFlight = newJob.voyageFlight.substr(0, 255)
      }
      // 件数
      const quantityContract = this.changeValue(job, 'numberOfPieces', ['CASE', 'PKGS', 'CTNS'])
      if (quantityContract !== 0) {
        newJob.quantityContract = Number(!StrUtils.isEmpty(job.packing.value) ? quantityContract.replace(job.packing.value, '') : quantityContract)
        newJob.quantityActual = newJob.quantityContract
      }
      // 毛重
      const weightContract = this.changeValue(job, 'grossWeight', ['KGS', this.$t('SeaExport.KG'), ','])
      newJob.weightContract = Number(weightContract)
      newJob.weightActual = newJob.weightContract
      // 体积
      const cubageContract = this.changeValue(job, 'volume', ['CBM', this.$t('SeaExport.CBM')])
      newJob.cubageContract = Number(cubageContract)
      newJob.cubageActual = newJob.cubageContract
      // 计费重量RT, 默认根据实际计算
      // newJob.chargeWeight = Number(cubageContract)
      let calWeight = newJob.weightActual
      let calCubage = newJob.cubageActual
      const chargeWeightCalculationMode = Number(cache.config.get('ChargeWeightCalculationMode'))
      if (chargeWeightCalculationMode === 1) { // 按委托进行计算
        calWeight = newJob.weightContract
        calCubage = newJob.cubageContract
      }
      calWeight = calWeight / 1000
      if (calCubage > calWeight) {
        calWeight = calCubage
      }
      if (calWeight > 0 && calWeight < 1) {
        calWeight = 1.00
      }
      newJob.chargeWeight = parseFloat(calWeight.toFixed(3))
      // 品名
      newJob.cargoEnglishName = job.goodName.value.toUpperCase()
      // 唛头
      newJob.mark = job.marks.value.toUpperCase()
      // 备注
      newJob.remarks = job.remarks.value
      // 联系人
      newJob.customerContact = job.contacts.value
      // 货物尺寸
      newJob.measurements = job.goodSize.value
      newJob.fileSourceType = this.details['fileType']
      newJob.fileSourceName = this.details['fileName']
      newJob.filePreViewContent = this.details['filePreViewContent']
      newJob.fileSourceContent = this.details['fileSourceContent']
      // 运费条款
      const paymentTermHBL = this.changeCodeValue(job, 'paymenTerm', TYPE_NAMES.basic_data_PaymentTerm)
      if (!StrUtils.isEmpty(paymentTermHBL)) {
        newJob.paymentTermHBL = paymentTermHBL
      }
      // 运输条款job
      const freightTermHBL = this.changeCodeValue(job, 'serviceTerm', TYPE_NAMES.basic_data_ShippingTerm)
      if (!StrUtils.isEmpty(freightTermHBL)) {
        newJob.freightTermHBL = freightTermHBL
        newJob.freightTerm = freightTermHBL
      }
      // 贸易条款
      const incoTerm = this.changeCodeValue(job, 'deliveryTerm', TYPE_NAMES.basic_data_IncoTerm)
      if (!StrUtils.isEmpty(incoTerm)) {
        newJob.incoTerm = incoTerm
      }
      // 包装
      const packing = this.changeCodeValue(job, 'packing', TYPE_NAMES.basic_data_Packing, 'name')
      if (!StrUtils.isEmpty(packing)) {
        newJob.packing = packing
      }
      const seaEqs = job.eqs.value
      if (seaEqs && !StrUtils.isEmpty(seaEqs)) {
        if (seaEqs.length > 0) {
          for (const seaEq of seaEqs) {
            seaEq.eqQuantity = seaEq.eQuantity
            seaEq.eqSize = seaEq.eQsize
            seaEq.eqType = seaEq.eQtype
          }
        }
        newJob.seaEQ = seaEqs
      }
      // 整箱/拼箱  FCL/LCL
      newJob.containerLoadType = ''
      if (!StrUtils.isEmpty(job.fclOrLcl.value)) {
        // irs 返回关键字
        if (job.fclOrLcl.hasOwnProperty('code')) {
          newJob.containerLoadType = job.fclOrLcl.code
        }
        if (StrUtils.isEmpty(newJob.containerLoadType)) {
          newJob.containerLoadType = job.fclOrLcl.value
        }
      }
      // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
      // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
      if (!StrUtils.isEmpty(job.orderType.value)) {
        // irs 返回关键字
        let releaseType = 1
        if (job.orderType.hasOwnProperty('code')) {
          const orderType = job.orderType.code
          if (!StrUtils.isEmpty(orderType)) {
            if (orderType === 'ORIGINAL') {
              releaseType = 1
            } else if (orderType === 'SURRENDERED') {
              releaseType = 2
            } else if (orderType === 'SEA WAYBILL') {
              releaseType = 3
            }
          }
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(job.orderType.value)
        }
        newJob.seaCargoDoc = [{
          docType: 'HBL',
          releaseType: releaseType
        }]
      }
      newJob.danUNNo = this.details.uuid
      newJob.signMBL = false
      newJob.signHBL = false
      newJob.virtualHBL = false
      newJob.vgm = false
      newJob.ams = false
      newJob.hds = false
      newJob.comercialInspectation = false
      newJob.heating = false
      newJob.itmService = false
      newJob.mblOnly = false
      newJob.transfering = false
      newJob.batch = false
      newJob.salePrice = false
      return JSON.parse(JSON.stringify(newJob, (key, value) => {
        if (typeof value !== 'boolean') {
          if (!value || (Array.isArray(value) && !value.length || (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length))) {
            return undefined
          }
        }
        return value
      }))
    },
    scnChange(job, newJob, sourceField, targetField) {
      for (let i = 7; i >= 0; --i) {
        if (job[sourceField + i]) {
          newJob[targetField + i] = job[sourceField + i].toUpperCase()
        }
      }
    },
    toDateStr(dateStr) {
      if (!dateStr) {
        return ''
      }
      // 验证日期距离1970年是多长时间，转换之后是否是数字、验证传入的日期是否是数字，若是数字则长度不能少于8位
      if (isNaN(Date.parse(dateStr)) || dateStr.length < 8) {
        return ''
      }
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 验证日期转换之后年月日是否正确
      if (isNaN(year) || isNaN(month) || isNaN(day) || month <= 0 || month > 12 || day < 0 || day > 31) {
        return ''
      }
      return DateUtils.formatStandardDate(date)
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField].value)) {
        if (job[targetField].hasOwnProperty('convertValue')) {
          result = job[targetField].convertValue
        }
        if (StrUtils.isEmpty(result)) {
          result = job[targetField].value
          result = result.trim()
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    },
    changeCodeValue(job, fieldKey, typeName, sourceField, targetField, useCode) {
      let result = null
      if (!StrUtils.isEmpty(job[fieldKey].value)) {
        // irs 返回关键字
        if (job[fieldKey].hasOwnProperty('code')) {
          result = job[fieldKey].code
        }
        //
        if (!StrUtils.isEmpty(result) && useCode) {
          const valueCode = ColumnUtils.resolveColumnLabel(typeName, (!StrUtils.isEmpty(sourceField) ? sourceField : 'code'), result, (!StrUtils.isEmpty(targetField) ? targetField : 'code'))
          if (valueCode !== null) {
            result = valueCode
          }
        }
        if (StrUtils.isEmpty(result)) {
          const valueCode = ColumnUtils.resolveColumnLabel(typeName, (!StrUtils.isEmpty(sourceField) ? sourceField : 'code'), job[fieldKey].value, (!StrUtils.isEmpty(targetField) ? targetField : 'code'))
          if (valueCode !== null) {
            result = valueCode
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking-result-dialog{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body{
    padding: 0!important;
    display: flex;
    flex:1;
    overflow: hidden;
  }
}
</style>
